const useScrollY = () => {
    let scrollY;

    let getWindowScrollY = () => {
        const doc = document.documentElement;
        scrollY = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        window.requestAnimationFrame(getWindowScrollY);
    };
    getWindowScrollY();

    return { scrollY };
};

export default useScrollY;
